import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

const MuiContainer = {
  styleOverrides: {
    root: ({ theme }: { theme: Theme}) => ({
      boxSizing: 'border-box',
      paddingLeft: 16,
      paddingRight: 16,
      [theme.breakpoints.up('md')]: {
        paddingLeft: 80,
        paddingRight: 80
      },
      [theme.breakpoints.up('lg')]: {
        maxWidth: 1440
      },
      '&.slim': {
        [theme.breakpoints.up('md')]: {
        paddingLeft: 150,
        paddingRight: 150
      }
      }
    })
  }
} as Components['MuiContainer'];

export default MuiContainer;
